import { render, staticRenderFns } from "./addSalesman.vue?vue&type=template&id=35158e74&scoped=true&"
import script from "./addSalesman.vue?vue&type=script&lang=js&"
export * from "./addSalesman.vue?vue&type=script&lang=js&"
import style0 from "./addSalesman.vue?vue&type=style&index=0&id=35158e74&lang=scss&scoped=true&"
import style1 from "./addSalesman.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35158e74",
  null
  
)

export default component.exports